import { closeDrawer } from '@console/actions/actions';
import type { AppThunkDispatch } from '@console/actions/thunkType';
import SideDrawer from '@console/components/project/Drawer';
import type { AppState } from '@console/reducers';
import { getIsMypageProject } from '@console/selectors/projectDetail';
import {
  getIsApiProject,
  getIsBulkProject,
  getIsGcpProject
} from '@console/selectors/projectDetail/solutionSystem';
import { connect } from 'react-redux';
import type { Location } from 'react-router';

const isSelectedMenu = (location: Location, contentName: string) => {
  const regexp = new RegExp(`/projects/(.*/)${contentName}`);
  return location.pathname.search(regexp) !== -1;
};

const mapStateToProps = (state: AppState) => ({
  isApiProject: getIsApiProject(state),
  isBulkProject: getIsBulkProject(state),
  isGcpProject: getIsGcpProject(state),
  isDrawerOpen: state.isDrawerOpen,
  isSampleProject: state.projectDetail.isSample,
  isMypageProject: getIsMypageProject(state),
  isAnyContentPartnerReviewRequestedProject:
    state.projectDetail.isAnyContentPartnerReviewRequested
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  closeDrawer: () => dispatch(closeDrawer()),
  isSelectedMenu: (location: Location, contentName: string) =>
    isSelectedMenu(location, contentName)
});

export type DrawerPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type DrawerPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer);
